import { rootApi } from '../rootApi';

export const warrantyReportsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        GetWarrantyReport: builder.query({
            query: (params) => {
                return {
                    url: `api/warrantyreports/getwarrantyreports`,
                    method: 'GET',
                    params: {
                        PageNumber: params.pageNumber,
                        PageSize: params.pageSize,
                        ReportType: params.reportType,
                        DealerId: params.dealerId,
                        StartDate: params.startDate,
                        EndDate: params.endDate,
                        IsDomestic: params.isDomestic,
                        ItemCode: params.itemCode,
                        ChassisNumber: params.chassisNumber,
                        LanguageId: params.languageId
                    }
                };
            }
        }),
        getPartReplacementDetails: builder.query({
            query: (params) => {
                return {
                    url: `api/warrantyreports/getPartReplacementDetails`,
                    method: 'GET',
                    params: {
                        PageNumber: params.pageNumber ?? 1,
                        PageSize: params.pageSize ?? 10,
                        ItemCode: params.itemCode,
                        ChassisNumber: params.chassisNumber || undefined,
                        DealerId: params.dealerId ?? undefined,
                        FailureDate: params.failureDate || undefined,
                        ClaimDate: params.claimDate || undefined,
                        FailureStartDate: params.failureStartDate || undefined,
                        FailureEndDate: params.failureEndDate || undefined,
                        Status: params.status ?? undefined,
                        CountryCode: params.countryCode || undefined,
                        IsScrap: params.isScrap ?? undefined,
                        WarrantyType: params.warrantyType ?? undefined,
                        Models: Array.isArray(params.models) && params.models.length ? params.models.join(',') : undefined,
                        LanguageId: params.languageId ?? 1
                    }
                };
            }
        }),
        exportDealerChassisCosts: builder.query({
            query: (params) => ({
                url: 'api/warrantyreports/exportDealerChassisCosts',
                method: 'GET',
                params: {
                    DealerId: params.DealerId,
                    StartDate: params.StartDate,
                    EndDate: params.EndDate,
                    IsDomestic: params.IsDomestic,
                    CompressionType: params.CompressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const data = response.data;
                    return {
                        fileBase64: data.fileBase64,
                        fileName: data.fileName,
                        contentType: data.contentType,
                        recordCount: data.recordCount,
                        fileSize: data.fileSize,
                        isCompressed: data.isCompressed
                    };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        }),
        exportAllClaimsReports: builder.query({
            query: (params) => ({
                url: 'api/warrantyreports/exportAllClaimsReports',
                method: 'GET',
                params: {
                    DealerId: params.DealerId,
                    StartDate: params.StartDate,
                    EndDate: params.EndDate,
                    IsDomestic: params.IsDomestic,
                    LanguageId: params.LanguageId,
                    CompressionType: params.CompressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const data = response.data;
                    return {
                        fileBase64: data.fileBase64,
                        fileName: data.fileName,
                        contentType: data.contentType,
                        recordCount: data.recordCount,
                        fileSize: data.fileSize,
                        isCompressed: data.isCompressed
                    };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        }),
        exportMostReplacedParts: builder.query({
            query: (params) => ({
                url: 'api/warrantyreports/exportMostReplacedParts',
                method: 'GET',
                params: {
                    ItemCode: params.ItemCode,
                    CompressionType: params.CompressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const data = response.data;
                    return {
                        fileBase64: data.fileBase64,
                        fileName: data.fileName,
                        contentType: data.contentType,
                        recordCount: data.recordCount,
                        fileSize: data.fileSize,
                        isCompressed: data.isCompressed
                    };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        })
    })
});

export const { useGetWarrantyReportQuery, useGetPartReplacementDetailsQuery, useLazyExportAllClaimsReportsQuery, useLazyExportDealerChassisCostsQuery, useLazyExportMostReplacedPartsQuery } = warrantyReportsApi;
